function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React from 'react';
import PropTypes from 'prop-types';
import StyledGlobalStyle from './GlobalStyle.style';
import themes from '@nab/nui-themes-web';
GlobalShadowStyle.propTypes = {
  /** normalize css for better cross browser rendering */
  normalize: PropTypes.bool,

  /** set all elements to use box-sizing: border-box */
  borderBox: PropTypes.bool,

  /** Used to set a custom CDN Path to read the fonts from
   * @deprecated Use NUI-Theme for customCDN
   */
  customCDN: PropTypes.shape({
    assetsPath: PropTypes.shape({
      fonts: PropTypes.string.isRequired,
      images: PropTypes.string
    }).isRequired,
    cdnUrl: PropTypes.string.isRequired
  }),

  /** theme name
   * @deprecated NOT USED
   */
  theme: PropTypes.oneOf(_toConsumableArray(Object.keys(themes)))
};
GlobalShadowStyle.defaultProps = {
  normalize: false,
  borderBox: false
};
export function GlobalShadowStyle(_ref) {
  var normalize = _ref.normalize,
      borderBox = _ref.borderBox;
  return /*#__PURE__*/React.createElement(StyledGlobalStyle, {
    normalize: normalize,
    borderBox: borderBox
  });
}